import { RootState } from "store";
export const system = (state:RootState) => state.system;

export const isKioskSelector = (state:RootState) => state.system.isKiosk;
export const isMobile = (state:RootState) => state.system.isMobile;